/**
 * Device service — runtime environment detection and formatting utilities.
 * Import and call these functions where needed instead of inheriting from a base class.
 */

export const mobileQuery = window.matchMedia('(max-width: 768px)');

export function isMobile() {
    return mobileQuery.matches;
}

export function isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches;
}

export function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
}
